/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TileRateApartment_jsonld } from './TileRateApartment_jsonld';
import type { TileRateCancellation_jsonld } from './TileRateCancellation_jsonld';
import type { TileRatePrepayment_jsonld } from './TileRatePrepayment_jsonld';
import type { TileRateProvision_jsonld } from './TileRateProvision_jsonld';
export type TileRate_jsonld = {
    readonly '@context'?: string | Record<string, any>;
    readonly '@id'?: string;
    readonly '@type'?: string;
    apartment?: TileRateApartment_jsonld | null;
    discount?: number;
    baseRate?: number;
    rate?: number;
    convertedRate?: number;
    convertedBaseRate?: number;
    convertedCurrency?: TileRate_jsonld.convertedCurrency;
    checkIn?: string | null;
    checkOut?: string | null;
    guests?: number;
    provision?: TileRateProvision_jsonld;
    cancellationPolicy?: TileRateCancellation_jsonld;
    prepayment?: TileRatePrepayment_jsonld;
};
export namespace TileRate_jsonld {
    export enum convertedCurrency {
        UNKNOWN = 'Unknown',
        HUF = 'HUF',
        EUR = 'EUR',
        GBP = 'GBP',
        RON = 'RON',
        PLN = 'PLN',
        USD = 'USD',
        CZK = 'CZK',
    }
}
